
export const sessionId = {
    profile: 'ID_profiles',
    profileFilter: 'ID_profileFilter',
    workDepartment: 'ID_workdepartment',
    applicationType: 'ID_applicationType',
    contractType: 'ID_contractType',
    contractTypeDuration: 'ID_contractTypeDuration',
    contractTerminationReason: 'ID_contractTemrinationReason',
    contractExtra: 'ID_contractExtra',
    proflieTag: 'ID_profileTag',
    notPresentType: 'ID_notPresentType',
    notPresentColumnFilter: 'ID_notPresentColumnFilter',
    token: "ID_token",
    roles: "ID_roles",
    payrollOffice: "ID_payrollOffice",
    workTimes: "ID_worktimes",
    timetable: "ID_timetable",
    timetableTemplate: "ID_timetabletemplate",
    contractJobTitle: "ID_contractJobTitle",
    contractSalaryLevel: "ID_contractSalaryLevel",
    workSafetyCourse: "ID_worksafetycourse",
    workSafetyCourseGroup: "ID_worksafetycoursegroup"
}